/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Portal_CopiedInputs */

const en_booking_portal_copied = /** @type {(inputs: Booking_Portal_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied.`)
};

const pl_booking_portal_copied = /** @type {(inputs: Booking_Portal_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano.`)
};

/**
* | output |
* | --- |
* | "Copied." |
*
* @param {Booking_Portal_CopiedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_copied = /** @type {((inputs?: Booking_Portal_CopiedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_CopiedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_copied(inputs)
	return en_booking_portal_copied(inputs)
});